export default "__VITE_ASSET__C$q$fKzL__"